import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface AutocompleteDriver extends BaseUniDriver {}

export const autocompleteDriverFactory = (
  base: UniDriver,
): AutocompleteDriver => {
  return {
    ...baseUniDriverFactory(base),
    // TODO - migrate to unidriver
  };
};
